import { Card } from "reactstrap";
import "./index.css";
import InfoIcon from "Assets/Icons/InfoIcon";
import { Col, Row, Tooltip, Button } from "reactstrap";
import Typography from "Components/CommonComponents/Typography";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import DataNotFound from "Assets/Icons/DataNotFound";
import AttendanceCardgroup from "Pages/MySchedule/Attendance/AttendanceCardgroup";
import AttendanceCardFooter from "Pages/MySchedule/Attendance/AttendanceCardFooter";
import ReportLog from "./ReportLogo.svg";
import { useContext, useEffect, useState } from "react";
import { Skeleton } from "antd";
import AttendanceCardView from "Pages/MySchedule/Attendance/AttendanceCardView";
import { format, setHours, setMinutes, setSeconds, subDays } from "date-fns";
import moment from "moment";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { UserInfoContext } from "Context/CommonContext";
import { ExclamationCircleTwoTone } from "@ant-design/icons";
import { ConfigProvider, theme } from "antd";
import useViewAccess from "Pages/MySchedule/Hooks/useViewAccess";
import { UserRoles } from "utilFunctions/Constants/UserRoles";
interface IAttendanceCardList {
  scheduleData?: any;
  screen?: any;
  studentList?: any;
  isStudentListLoading?: any;
  handleAttendance?: any;
  handleAbsent?: any;
  totalStudentList?: any;
  presentStudentList?: any;
  onlineStudentList?: any;
  isUnmarkedVisible?: any;
  setIsUnmarkedVisible?: any;
  handleFilterForStudent?: any;
  selectedFilter?: any;
  handleStudentStatus?: any;
  presentLength?: any;
  absentLength?: any;
  onlineLength?: any;
  unmarkedlength?: any;
  unmarkedlengthLOP?: any;
  isLOPStudentSaveEnable?: any;
  handleMarkAttendance?: any;
  handleUnmarkFilterForStudent?: any;
  setIsModalOpen?: any;
  reportedStudentList?: any;
  handleDeleteStudentStatus?: any;
  fetchLeftOutStudents?: any;
  studentLOPlist?: any;
  notShowFooter?: boolean;
  isHideAttendanceButton?: boolean;
}
function AttendanceCardList({
  studentList,
  isStudentListLoading,
  scheduleData,
  screen,
  handleAttendance,
  handleAbsent,
  presentStudentList,
  onlineStudentList,
  handleStudentStatus,
  handleMarkAttendance,
  totalStudentList,
  onlineLength,
  absentLength,
  presentLength,
  unmarkedlength,
  setIsModalOpen,
  isUnmarkedVisible,
  handleUnmarkFilterForStudent,
  setIsUnmarkedVisible,
  handleDeleteStudentStatus,
  fetchLeftOutStudents,
  studentLOPlist,
  isLOPStudentSaveEnable,
  notShowFooter = false,
  isHideAttendanceButton = false,
}: IAttendanceCardList) {
  const { isViewOnly } = useViewAccess({
    UserRoleAccess: [UserRoles.academicCounsellor],
  });
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { token } = theme.useToken();
  const cardListData = [...studentList].filter(
    (el: any) => el.studentName != null
  );
  cardListData.sort((a: any, b: any) =>
    a.studentName.localeCompare(b.studentName)
  );
  const cardListDataNotNull = [...studentList].filter(
    (el: any) => el.studentName == null
  );
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const groupedStudent: any = {};
  cardListData.forEach((user: any, index: any) => {
    const firstChar = user.studentName.charAt(0).toUpperCase();
    if (!groupedStudent[firstChar]) {
      groupedStudent[firstChar] = [];
    }
    user.serialNumber = index + 1;
    groupedStudent[firstChar].push(user);
  });
  const NotMarkedChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const notMarked = event.target.checked;
    setIsUnmarkedVisible(notMarked);
    handleUnmarkFilterForStudent(notMarked);
  };
  const dateViewData = moment(scheduleData?.endTime)
    .utcOffset("+05:30")
    .format()
    .split("T")[0];
  const todayDate = moment().utcOffset("+05:30").format().split("T")[0];
  const past7Days = format(
    setSeconds(setMinutes(setHours(subDays(new Date(), 5), 18), 30), 0),
    "yyyy-MM-dd"
  );
  const time = moment(scheduleData?.endTime);
  const checkValidation = () => {
    let retVal = false;
    if (isViewOnly) return true;
    const now = moment();
    const endTime = moment(scheduleData?.endTime);
    const isFaculty = userInfo?.fexRole === "Faculty";
    const isWithin2Hours = now.isSameOrBefore(endTime.clone().add(2, "hours"));

    if (
      isFaculty &&
      (!isWithin2Hours ||
        unmarkedlength !== 0 ||
        !isLOPStudentSaveEnable ||
        dateViewData !== todayDate)
    ) {
      retVal = true;
    } else if (
      !isFaculty &&
      (unmarkedlength !== 0 ||
        !isLOPStudentSaveEnable ||
        (!time.isBetween(past7Days, todayDate) && dateViewData !== todayDate))
    ) {
      retVal = true;
    } else {
      retVal = false;
    }
    return retVal;
  };

  useEffect(() => {
    fetchLeftOutStudents();
  }, [scheduleData?.batchTimeTableId]);
  return (
    <>
      <Card
        className="d-flex mt-3 attendance-header-list-conteniner rounded-top mb-0"
        style={{
          backgroundColor: "#F5F5F5",
          borderRadius: "8px 8px 0px 0px !important",
        }}
      >
        <div>
          <Row className="mb-0">
            <Col
              xs="12"
              sm="12"
              md="12"
              lg="12"
              className="d-flex justify-content-start"
            >
              <div className="w-100 d-flex flex-row justify-content-between align-items-center">
                <div className="d-flex flex-row align-items-center">
                  {["xxl", "xl", "lg"].includes(screen) && (
                    <div className="d-flex flex-column">
                      <div>
                        <Typography
                          variant={
                            ["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"
                          }
                          color="black"
                        >
                          {"Total students | "} {totalStudentList.length}
                        </Typography>
                      </div>
                    </div>
                  )}
                </div>

                {["xxl", "xl", "lg"].includes(screen) && (
                  <div className="d-flex flex-row">
                    <div className="notmarkedContainerStyle d-flex align-items-center ml-4">
                      <input
                        className="form-check-input filterCheckbox mr-2"
                        type="checkbox"
                        checked={isUnmarkedVisible}
                        onChange={NotMarkedChangeHandler}
                        disabled={isViewOnly}
                      />
                      <div className="d-flex flex-row align-items-center">
                        <Typography variant="body3" color="gray">
                          Unmarked students
                        </Typography>
                        <InfoIcon id={"Tooltip-student-attendance"}></InfoIcon>
                        <Tooltip
                          placement={"bottom"}
                          isOpen={tooltipOpen}
                          target={"Tooltip-student-attendance"}
                          toggle={toggle}
                        >
                          {
                            "Students who are left to be marked present, online or absent"
                          }
                        </Tooltip>
                      </div>
                      <div className="d-flex flex-row">
                        <Button
                          color={"danger"}
                          disabled={checkValidation()}
                          outline
                          size="sm"
                          style={{
                            marginLeft: "24px",
                            height: "28px",
                            width: "auto",
                          }}
                          onClick={() => {
                            !checkValidation() ? setIsModalOpen(true) : {};
                          }}
                        >
                          <div className="d-flex flex-row align-items-center">
                            <span> Report Issue</span>
                            <img
                              className="ml-1"
                              height={18}
                              width={18}
                              src={ReportLog}
                            />
                          </div>
                        </Button>
                      </div>
                    </div>
                  </div>
                )}

                {!["xxl", "xl", "lg"].includes(screen) && (
                  <div className="d-flex flex-row justify-content-between w-100">
                    <div className="pe-auto w-100 d-flex justify-content-between align-items-center">
                      <div className="d-flex flex-row align-items-center">
                        <Typography
                          variant={
                            ["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"
                          }
                          color="black"
                        >
                          {"Total students | "} {totalStudentList.length}
                        </Typography>
                      </div>
                      <div
                        className="d-flex flex-row align-items-center"
                        style={{ marginRight: "16px" }}
                      >
                        <input
                          className="form-check-input filterCheckbox mr-2"
                          type="checkbox"
                          checked={isUnmarkedVisible}
                          onChange={NotMarkedChangeHandler}
                        />
                        <Typography variant="body3" color="gray">
                          Unmarked
                        </Typography>
                        <InfoIcon id={"Tooltip-student-attendance"}></InfoIcon>
                        <Tooltip
                          placement={"bottom"}
                          isOpen={tooltipOpen}
                          target={"Tooltip-student-attendance"}
                          toggle={toggle}
                        >
                          {
                            "Students who are left to be marked present, online or absent"
                          }
                        </Tooltip>
                      </div>
                    </div>
                    <div className="pe-auto d-flex align-items-center">
                      <Button
                        color={"danger"}
                        disabled={checkValidation()}
                        outline
                        size="sm"
                        style={{
                          marginLeft: "8px",
                        }}
                        onClick={() => {
                          !checkValidation() ? setIsModalOpen(true) : {};
                        }}
                      >
                        <img src={ReportLog} />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Card>
      <Card
        className={
          ["xs", "sm", "md"].includes(screen)
            ? "cardListAttendanceContainerMB rounded-bottom"
            : "cardListAttendanceContainer rounded-bottom"
        }
        style={{ borderRadius: "0px 0px 8px 8px !important" }}
      >
        <>
          {isStudentListLoading ? (
            ["1", "2", "3", "4"].map((el: any, index: number) => (
              <>
                <Skeleton
                  key={el + index}
                  avatar
                  paragraph={{ rows: 1 }}
                  className="border-bottom mt-2 pr-3"
                />
              </>
            ))
          ) : (cardListData && cardListData.length > 0) ||
            (studentLOPlist && studentLOPlist.length) ? (
            <>
              {Object.keys(groupedStudent).map((char: any) => (
                <AttendanceCardgroup
                  screen={screen}
                  key={char}
                  groupChar={char}
                  students={groupedStudent[char]}
                  handleAttendance={handleAttendance}
                  handleAbsent={handleAbsent}
                  presentStudentList={presentStudentList}
                  onlineStudentList={onlineStudentList}
                  handleStudentStatus={handleStudentStatus}
                  handleDeleteStudentStatus={handleDeleteStudentStatus}
                />
              ))}
              {/* {Array.isArray(cardListDataNotNull) &&
              cardListDataNotNull.length ? (
                <Divider className="divider-custom-style" />
              ) : null} */}

              {Array.isArray(cardListDataNotNull) && cardListDataNotNull.length
                ? cardListDataNotNull.map((user: any, index: any) => {
                    const newUser = { ...user };
                    newUser["serialNumber"] = cardListData.length + index + 1;
                    return (
                      <>
                        <div
                          key={user.psid}
                          className={`student-CardView ${
                            index == cardListDataNotNull.length - 1 ? "" : ""
                          }`}
                        >
                          <AttendanceCardView
                            key={user.psid}
                            cardData={newUser}
                            screen={screen}
                            handleAttendance={handleAttendance}
                            handleAbsent={handleAbsent}
                            presentStudentList={presentStudentList}
                            onlineStudentList={onlineStudentList}
                            handleStudentStatus={handleStudentStatus}
                            handleDeleteStudentStatus={
                              handleDeleteStudentStatus
                            }
                          />
                        </div>
                      </>
                    );
                  })
                : null}
              <ConfigProvider
                theme={{
                  components: {
                    Collapse: {
                      // Seed Token
                      contentBg: token.colorWhite,
                      contentPadding: 0,

                      // Alias Token
                      headerBg: token.colorFillAlter,
                      headerPadding: 16,
                    },
                  },
                }}
              >
                <label style={{ marginTop: "10px" }}>Left Out Students</label>
                {studentLOPlist &&
                Array.isArray(studentLOPlist) &&
                studentLOPlist.length ? (
                  studentLOPlist.map((user: any, index: any) => {
                    const newUser = { ...user };
                    newUser["serialNumber"] =
                      cardListData.length +
                      cardListDataNotNull.length +
                      index +
                      1;
                    return (
                      <div
                        key={user.psid}
                        className={`student-CardView ${
                          index == studentLOPlist.length - 1 ? "" : ""
                        }`}
                      >
                        <AttendanceCardView
                          key={user.psid}
                          cardData={newUser}
                          screen={screen}
                          handleAttendance={handleAttendance}
                          handleAbsent={handleAbsent}
                          presentStudentList={presentStudentList}
                          onlineStudentList={onlineStudentList}
                          handleStudentStatus={handleStudentStatus}
                          handleDeleteStudentStatus={handleDeleteStudentStatus}
                        />
                      </div>
                    );
                  })
                ) : (
                  <div className="d-flex flex-row align-items-center">
                    <ExclamationCircleTwoTone
                      style={{ fontSize: "16px" }}
                      twoToneColor="#eb2f96"
                    />
                    <span className="no-lop-student-info ml-2">
                      No Left Out students found
                    </span>
                  </div>
                )}
              </ConfigProvider>
            </>
          ) : (
            <div className="d-flex justify-content-center align-items-center h-100">
              <NoResultFoundSearch
                primaryMessage="No student found."
                secondaryMessage={
                  "No student found in this batch. Please connect with your EDP Team."
                }
              >
                <DataNotFound />
              </NoResultFoundSearch>
            </div>
          )}
        </>

        <AttendanceCardFooter
          userInfo={userInfo}
          screen={screen}
          scheduleData={scheduleData}
          totalStudentList={totalStudentList}
          presentStudentList={presentStudentList}
          presentLength={presentLength}
          absentLength={absentLength}
          unmarkedlength={unmarkedlength}
          onlineLength={onlineLength}
          handleMarkAttendance={handleMarkAttendance}
          isLectureSaveEnableForRole={checkValidation()}
          isLOPStudentSaveEnable={isLOPStudentSaveEnable}
          notShowFooter={notShowFooter}
          isHideAttendanceButton={isHideAttendanceButton}
        />
      </Card>
    </>
  );
}

export default AttendanceCardList;
